import React from 'react';

const Members = () => {
    return(
        <div className="Members">
          <div>
            <div className="Member">
              <div className="MemberStatus offline" />
              Hartej Lehal
            </div>
            <div className="Member">
              <div className="MemberStatus online" />
              cleverbot
            </div>
          </div>
        </div>
    )
}

export default Members;